'use strict';

/**
 * Collection for the units
 *
 * @category   Collection
 * @module     base
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Collection = require('base/Colido.Collection');
var UnitModel = require('modules/base/models/unit');

var UnitsCollection = Collection.extend({
    api: '/core/units',

    name: 'base:units',

    sortDefault: 'order.asc',

    model: UnitModel,
});

module.exports = UnitsCollection;